import { Identifiable, Tagged, Zone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = Tagged<Identifiable<Zone>>;

function getZone(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Zone>) =>
    new Promise<Tagged<Identifiable<Zone>>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Response>({
          endpoint: `/zones/${uuid}`,
          method: HttpMethods.GET,
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { getZone };
